export default __webpack_public_path__ + "static/media/wi-bank.e3af1d46.png";